import { ReducerCreators } from '@reduxjs/toolkit';

import { Get } from '@/connection/helpers';
import { BtvMedia, BtvMediaState } from './types';
import { isEmpty } from 'underscore';
import { RootState } from '@/store/main';

const BTV_API_HOST = `https://api.${import.meta.env.VITE_BRAND_TV_DOMAIN}`;

type BtvMediaResponse = {
  status: boolean;
  success: {
    code: string;
    message: string;
    data: BtvMedia;
  };
  error: null | string;
};

export const reducers = (create: ReducerCreators<BtvMediaState>) => ({
  fetchBtvMedia: create.asyncThunk(
    async (projectUuid: string, { rejectWithValue }) => {
      try {
        const res = await Get<BtvMediaResponse>({
          host: BTV_API_HOST,
          path: `/api/v1/dash/media/project/${projectUuid}`,
        });

        if (res.success.data && !isEmpty(res.success.data)) {
          return res.success.data;
        }
        return null;
      } catch (e) {
        return rejectWithValue(e);
      }
    },
    {
      fulfilled: (state, action) => {
        state.btvMedia = action.payload;
        state.loadingBtvMedia = false;
      },
      pending: (state) => {
        state.loadingBtvMedia = true;
      },
      rejected: (state, action) => {
        state.loadingBtvMedia = false;
        console.error(action.error);
      },
      options: {
        condition: (_, { getState }) => {
          const state = getState() as RootState;
          return !state.btvMedia.loadingBtvMedia;
        },
      },
    }
  ),
  clearBtvMedia: create.reducer((state) => {
    state.btvMedia = null;
  }),
});
